import React, { useEffect, useState } from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import ViewModal from "../Modal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "axios";
import { toast } from "react-toastify";
import ProductCard from "../Cards/ProductCard";
import { Grid, Pagination, Rating } from "@mui/material";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import LoadingCard from "../Cards/LoadingCard";

import "./noonbar.css";
import { MoonLoader } from "react-spinners";
import DeleteIcon from "../../icons/DeleteIcon";
import BuyNowIcon from "../../icons/BuyNowIcon";
import PriceSlider from "./PriceRangeBar";
import { checkLoggedIn } from "../../utils";
import { useLoginModal } from "../../Context/LoginModalContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

const BuyNoonPricebar = ({ addToCartProduct, addToWishListProduct, addToCompareListProduct, ...props }) => {
  const [open, setOpen] = React.useState(false);

  const [price, setPrice] = useState(1000);

  const { openLoginModal } = useLoginModal();

  const [popularcategories, setPopularcategories] = useState([]);
  const [state, setState] = useState({});
  const [value, setValue] = React.useState(0);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 4,
    totalRecords: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  function handleClose() {
    setOpen(false);
  }
  const handleClickOpen = (item) => {
    setOpen(true);
    setState(item);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePageChange = (event, value) => {
    setFilter((prev) => ({ ...prev, page: value }));
  };

  const getSingleProductData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("get-products", {
        params: { slug: "noon-24" },
      })
      .then((res) => {
        let singleProduct = {
          ...res?.data?.data?.[0],
          id: res?.data?.data?.[0]?._id,
        };
        setPopularcategories(singleProduct);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };
  const fetchPopularcategories = () => {
    setLoading(true);
    if (error) setError(false);
    axios
      .get("get-products", {
        params: { popularcategories: true, ...filter },
      })
      .then((response) => {
        const data = response?.data?.data;
        setPopularcategories(data?.map((el) => ({ ...el, id: el._id })));
        setFilter((prev) => ({
          ...prev,
          totalRecords: response?.data?.totalRecords,
        }));
      })
      .catch((error) => {
        setPopularcategories([]);
        setError(true);
        toast.error(error.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  console.log({ popularcategories });
  useEffect(() => {
    getSingleProductData();
    // fetchPopularcategories();
  }, [filter.page]);

  return (
    <section className="popular-category-section sm-separator-padding">
      <div className="sm-container">
        {/* <div class="custom-shape-popular-right-top"></div> */}
        {/* <div class="custom-glow-popular-left"></div> */}

        {/* <div class="custom-shape-popular-left-bottom"></div> */}
        {/* <div class="custom-glow-popular-bottom"></div> */}

        <div className="row justify-content-center">
          <div className="col-lg-6 mb-5 text-center">
            {/* <SectionTitle
              sTitle={"Popular Categories"}
              sClass={"heading-title-s2"}
            /> */}
            <p style={{ color: "#EEBA0E" }} className="title-first-popular text-center ">
              Noon Price bar
            </p>
            {/* <span className="title-second-popular">Categories</span> */}
          </div>
        </div>
        {loading ? (
          <>
            <div className="grid-4 w-full">
              {new Array(filter?.limit || 4).fill(1)?.map((el) => {
                return <LoadingCard />;
              })}
            </div>
            <div className="flex-justify-center-items-center pt-40 pb-40"></div>
          </>
        ) : popularcategories.length === 0 ? (
          <div>
            <h3>Oops! No Data Found!</h3>
          </div>
        ) : (
          <div className="">
            <div className="">
              {[popularcategories].length > 0 && (
                <>
                  {[popularcategories].map((product, index) => (
                    <div key={index} className="product-item-noon ">
                      <div className="product-item-noon-flex ">
                        <div className="">
                          {/* <img src={product?.proimg[0]?.src} alt={product.title} /> */}
                          <img src={"/noonimg.png"} alt={product.title} />
                        </div>

                        <div className="">
                          <div className="product-single-content ">
                            <h5 style={{ fontWeight: "650", fontSize: "30px", color: "#FFF894" }} className="">
                              {product?.title}
                            </h5>
                            <p style={{ color: "#FFF894" }}>{product?.description}</p>

                            <div className="flex items-center gap-10 mb-10">
                              <Rating
                                name="read-only"
                                sx={{
                                  "& .MuiRating-iconEmpty": {
                                    color: "grey",
                                  },
                                }}
                                precision={0.5}
                                value={+product?.five_start_rating}
                                readOnly
                                className="mt-2"
                              />{" "}
                              <span className="mt-2" style={{ color: "#FFF894" }}>
                                {product?.five_start_rating || 0}
                              </span>
                            </div>

                            <span style={{ color: "#FFF894" }} className="present-price">
                              <img src={"/aed-w.png"} alt={"aed"} height={"20px"} width={"20px"} style={{ objectFit: "contain" }} className="display-inline " />
                              {"  "}
                              {price}
                            </span>
                            <del style={{ color: "#FFFBC2" }} className="old-price">
                              {product?.delPrice}
                            </del>

                            <div className="stock">
                              <ul>
                                <li style={{ color: "#FFFBC2" }}>In stock : {product?.stock}</li>
                              </ul>
                            </div>
                            <div className="category">
                              <p className="mb-1 mt-2" style={{ color: "#FFFBC2" }}>
                                Category : {product?.category}
                              </p>

                              <p className="mb-1" style={{ color: "#FFFBC2" }}>
                                Brand : {product?.brand}
                              </p>
                            </div>

                            <PriceSlider ismobile={"price-slider-main-div"} setPrice={setPrice} price={price} />
                            <div className="pro-single-btn">
                              <button
                                style={{ width: "100%" }}
                                className="buy-now-btn me-2 mt-5"
                                data-tooltip-id="buy-now-button"
                                data-tooltip-content="Buy Now"
                                data-tooltip-place="top"
                                onClick={async () => {
                                  if (!checkLoggedIn()) {
                                    openLoginModal();
                                  } else {
                                    toast.error("Payment options are currently unavailable. Please visit the site again later.");
                                  }
                                }}
                                // disabled={cartLoading} // Disable button while cartLoading
                              >
                                Buy Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <PriceSlider ismobile={"price-slider-main-div-mobile"} setPrice={setPrice} price={price} />
                      <div className="pro-single-btn-mobile   ">
                        <button
                          style={{ width: "100%" }}
                          className="buy-now-btn me-2 mt-5"
                          data-tooltip-id="buy-now-button"
                          data-tooltip-content="Buy Now"
                          data-tooltip-place="top"
                          onClick={async () => {
                            if (!checkLoggedIn()) {
                              openLoginModal();
                            } else {
                              toast.error("Payment options are currently unavailable. Please visit the site again later.");
                            }
                          }}
                          // disabled={cartLoading} // Disable button while cartLoading
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            {popularcategories.length > 0 && (
              <div className="flex-justify-center-items-center pt-20 pb-20">
                <Pagination
                  count={Math.ceil(filter.totalRecords / filter.limit)}
                  size={"large"}
                  page={filter?.page}
                  defaultPage={filter?.page}
                  onChange={handlePageChange}
                  siblingCount={1}
                />
              </div>
            )}
          </div>
        )}
      </div>
      <ViewModal addToCartProduct={addToCartProduct} open={open} onClose={handleClose} product={state} carts={props.carts} {...props} />
    </section>
  );
};

export default BuyNoonPricebar;
